import { useTheme } from '@mui/material';

interface CatalogsIllustrationProps {
  width?: number | string;
  height?: number | string;
}

const CatalogsIllustration = ({ width = 130, height = 120 }: CatalogsIllustrationProps) => {
  const { palette } = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 130 120"
      fill="none"
      style={{ display: 'block' }}
    >
      <g>
        <g>
          <rect x="-303.5" y="-317" width="1365" height="767" fill={palette.action.hover} />
          <rect x="-303.5" y="-317" width="1365" height="767" stroke={palette.divider} />
          <g>
            <g>
              <g>
                <g clipPath="url(#catalogsIllustrationClip0)">
                  <path
                    d="M-100 -249.5C-100 -256.127 -94.6274 -261.5 -88 -261.5H1042C1048.63 -261.5 1054 -256.127 1054 -249.5V394.5C1054 401.127 1048.63 406.5 1042 406.5H-88C-94.6274 406.5 -100 401.127 -100 394.5V-249.5Z"
                    fill={palette.background.paper}
                  />
                  <g>
                    <rect
                      width="1154"
                      height="570"
                      transform="translate(-100 -159.5)"
                      fill="white"
                    />
                    <g>
                      <g>
                        <g>
                          <g>
                            <path
                              d="M65 108.546C97.5848 108.546 124 104.17 124 98.773C124 93.3755 97.5848 89 65 89C32.4152 89 6 93.3755 6 98.773C6 104.17 32.4152 108.546 65 108.546Z"
                              stroke={palette.text.disabled}
                              strokeWidth="1.57939"
                              strokeLinecap="round"
                              strokeDasharray="0.36 5.79"
                            />
                            <g>
                              <path
                                d="M67.4689 25.5365C67.4689 25.5365 49.9184 17.6474 31.0179 18.9623C26.5862 19.322 22.9627 20.272 20.5896 21.0588C18.6736 21.694 17.5176 23.5303 17.5176 25.5488V81.6156C17.5176 83.9219 19.7082 85.6444 21.9796 85.2445C25.2333 84.6717 29.9529 84.0474 35.068 84.0474C47.4393 84.0474 59.8105 88.2644 64.9675 90.258C66.1559 90.7173 67.4689 89.8418 67.4689 88.5678V25.5365Z"
                                fill={palette.custom.border.primary}
                                stroke={palette.custom.border.primary}
                                strokeWidth="1.7225"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M63.9512 25.5365C63.9512 25.5365 81.6252 17.6474 100.659 18.9623C105.128 19.3224 108.781 20.2746 111.17 21.0619C113.092 21.6953 114.254 23.5352 114.254 25.5589V82.1244C114.254 84.6169 111.703 86.3977 109.291 85.7695C106.039 84.9224 101.49 84.0474 96.5802 84.0474C84.1038 84.0474 71.6273 88.2767 66.4475 90.2667C65.2601 90.7228 63.9512 89.8476 63.9512 88.5755V25.5365Z"
                                fill={palette.custom.border.primary}
                                stroke={palette.custom.border.primary}
                                strokeWidth="1.7225"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M63.025 22.774C63.025 22.774 45.8 14.824 27.25 16.149C22.9071 16.5109 19.355 17.4659 17.0258 18.258C15.1336 18.9015 14 20.7239 14 22.7226V79.7724C14 82.2826 16.5887 84.0687 19.0148 83.4243C22.1717 82.5858 26.5285 81.7365 31.225 81.7365C43.3146 81.7365 55.4043 85.9496 60.5044 87.969C61.696 88.4408 63.025 87.5646 63.025 86.283V22.774Z"
                                fill="white"
                                stroke={palette.text.primary}
                                strokeWidth="0.70354"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M63.0254 22.774C63.0254 22.774 80.2504 14.824 98.8004 16.149C103.143 16.5109 106.695 17.4659 109.025 18.258C110.917 18.9015 112.05 20.7239 112.05 22.7226V79.7724C112.05 82.2826 109.462 84.0687 107.036 83.4243C103.879 82.5858 99.5219 81.7365 94.8254 81.7365C82.7358 81.7365 70.6461 85.9496 65.546 87.969C64.3544 88.4408 63.0254 87.5646 63.0254 86.283V22.774Z"
                                fill="white"
                                stroke={palette.text.primary}
                                strokeWidth="0.70354"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M63.0254 22.7744V86.5301"
                                stroke={palette.text.primary}
                                strokeWidth="0.70354"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <path
                  d="M-88 -261H1042C1048.35 -261 1053.5 -255.851 1053.5 -249.5V394.5C1053.5 400.851 1048.35 406 1042 406H-88C-94.3513 406 -99.5 400.851 -99.5 394.5V-249.5C-99.5 -255.851 -94.3513 -261 -88 -261Z"
                  stroke={palette.divider}
                  strokeLinecap="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="catalogsIllustrationClip0">
          <path
            d="M-100 -249.5C-100 -256.127 -94.6274 -261.5 -88 -261.5H1042C1048.63 -261.5 1054 -256.127 1054 -249.5V394.5C1054 401.127 1048.63 406.5 1042 406.5H-88C-94.6274 406.5 -100 401.127 -100 394.5V-249.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CatalogsIllustration;
